import { render, staticRenderFns } from "./SwitchCustom.vue?vue&type=template&id=dfe88c3a&scoped=true&"
import script from "./SwitchCustom.vue?vue&type=script&lang=js&"
export * from "./SwitchCustom.vue?vue&type=script&lang=js&"
import style0 from "./SwitchCustom.vue?vue&type=style&index=0&id=dfe88c3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe88c3a",
  null
  
)

export default component.exports